var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"card"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"title-card"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content-card"},[_c('v-icon',{attrs:{"color":_vm.icon.color}},[_vm._v(_vm._s(_vm.icon.icon))]),_c('span',[_vm._v(_vm._s(_vm.value))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }